// @ts-nocheck
/* eslint-disable */

'use client';

import {
	Button,
	Chip,
	Column,
	Flex,
	FrameCard,
	Heading,
	Icon,
	ImageWrapper,
	Row,
	Separator,
	ShareModal,
	Spacer,
	variables,
} from 'daskapital-ds';
import { Suspense, useState } from 'react';

import { BlocksProps } from '@/lib/wordpress/_types/blocksStyle';
import Link from 'next/link';
import NavigationEvents from '@/components/common/NavigationEvents/NavigationEvents';
import displayBlock from '@/lib/wordpress/blocks/displayBlock';
import { styled } from 'styled-components';
import { useGlobalContext } from '@/lib/globalContext';

const StyledBreadCrumbs = styled.ul`
	gap: 8px;
	row-gap: 0;
	flex-wrap: wrap;

	& a:hover {
		color: ${variables.colors.primary50};
	}
`;

const HelpCenterPost = (props: Record<string, unknown>) => {
	const { post, lastNews } = props;
	const state = useGlobalContext();
	const [shareOpen, setShareOpen] = useState(false);

	const { title, translatedURI, blocks } = post;

	const category = (post?.categories as unknown as Taxonomy[]) || [];
	const categories = category && Object.keys(category).length > 0 ? category[0]?.items : '';

	const relatedArticles = post?.acf?.related_faqs;

	return (
		<div>
			<Suspense>
				<NavigationEvents translatedURI={translatedURI || ''} acf={{ page_style: 'light', header_absolute: false }} />
			</Suspense>

			<Spacer customHeight="6rem" />
			<Row>
				<Column lg={2}></Column>
				<Column lg={8}>
					<StyledBreadCrumbs className="d-flex align-center font-alternative">
						<li>
							<Link href={`/${state.lang !== state?.i18n?.defaultLocale ? state.lang + "/" : ''}help-center`}>{state.dict?.post_types?.helpCenter}</Link>
						</li>
						<li>{'>'}</li>
						<li>
							<Link href={`/${state.lang !== state?.i18n?.defaultLocale ? state.lang + "/" : ''}help-center/category/${categories[0].slug}`}>{categories[0].name}</Link>
						</li>
						<li>{'>'}</li>
						<li>{title}</li>
					</StyledBreadCrumbs>
					<Flex gap="12px" justify="space-between" wrap="nowrap" className="w-100">
						<Heading tag="h1" size="h3">
							{title}
						</Heading>

						<Button className={"justify-content-center"} variant="primary" rightIcon={<Icon icon="icon-share" />} onClick={() => setShareOpen(true)}></Button>
					</Flex>

					<Spacer customHeight="3rem" />

					<Separator color={variables.colors.gray40} height={'1px'} className={'gray50'} />

					<Spacer customHeight="3rem" />

					<div className="single-postcontent">
						{!!(blocks as [])?.length &&
							(blocks as []).map((block: BlocksProps, index: number) => {
								return displayBlock(block, index);
							})}
					</div>
				</Column>
				<Column lg={2}></Column>
			</Row>

			{!!relatedArticles?.length && (
				<>
					<Spacer customHeight="6rem" />
					<Row>
						<Column md={1}></Column>
						<Column md={10}>
							<Heading tag="h4" size="h3" className="mb-4">
								{state?.dict?.custom?.related_faqs}
							</Heading>
						</Column>
						<Column md={1}></Column>
						<Column md={1}></Column>
						<Column md={10}>
							{relatedArticles.map((related: IPost, i: number) => {
								return (
									<Link href={related.slug as string} aria-label={`Read more about ${related.title}`}>
										<FrameCard key={`help-center-${i}`} title={related.title as string} className="mb-4" />
									</Link>
								);
							})}
						</Column>
						<Column md={1}></Column>
					</Row>
				</>
			)}

			{!!(lastNews?.blocks as [])?.length && (
				<>
					<Spacer customHeight="6rem" />
					<Row>
						<Column></Column>
						<Column>
							{(lastNews?.blocks as []).map((block: BlocksProps, index: number) => {
								return displayBlock(block, index);
							})}
						</Column>
					</Row>
				</>
			)}

			<ShareModal
				siteTitle={process.env.NEXT_PUBLIC_SITE_NAME}
				title={post.title}
				url={`${process.env.NEXT_PUBLIC_FE_URL}${post.slug}`}
				label={(state?.dict?.blog as Record<string, string>).shareBtn}
				copyText={(state?.dict?.blog as Record<string, string>).shareCopy}
				open={shareOpen}
				onClose={() => setShareOpen(false)}
				className="color-primary50"></ShareModal>
		</div>
	);
};
export default HelpCenterPost;
